// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"51e405c2","179":"82dd6114","389":"2b7c7287","438":"9e730bde","447":"4b91cabf","488":"75131827","514":"42ea18ca","600":"57784071","991":"b2ee600b"}[chunkId] + ".chunk.js";
};